import React from 'react'
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import PropTypes from 'prop-types'
function NotFound(props) {  
    const {errorMessage} = props

	return (
        <div className= {'main fw-bold mt-5 pt-5'}>
            <div>
                <h3 className="text-danger header-s text-center">Error!</h3>
                <h5 className="text-danger header-s text-center">{errorMessage ? errorMessage : 'Something Went Wrong'}</h5>
            </div>
        </div>
        
        )
}
NotFound.propTypes = {
	errorMessage: PropTypes.string
}

NotFound.defaulProps = {
	errorMessage: ''
	
}
export default NotFound
